export const getError = (errorObject) => {
  if (!errorObject) return null;
  if (errorObject.type === 'required')
    return 'An EPVS calculations file is required';
  return 'There is an issue with this file';
};
